import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'
import { NoContentData } from '@lastbrand/storefront-proto-registry/api/v1/widget'
import React from 'react'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { NoContentDSWidget } from './no-content-ds-widget'
import { NoContentLegacyWidget } from './no-content-widget-legacy'

const NoContentWidgetComponent = (props: PLTypedWidgetProps<NoContentData>) => {
  if (shouldUseDesignSystem()) {
    return <NoContentDSWidget {...props} />
  }
  return <NoContentLegacyWidget {...props} />
}

export const NoContentWidget: PLTypedWidgetInterface<NoContentData, WidgetType.NO_CONTENT> = {
  id: WidgetType.NO_CONTENT,
  errorBoundary: PLBaseErrorBoundary,
  render: NoContentWidgetComponent,
}
